var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "filters grid" },
    [
      _c("ma-input-select", {
        attrs: {
          type: "select",
          name: "warranty",
          col: "2",
          icon: "house",
          literal: "adminLayout.filters.warranty",
          options: _vm.warrantyTypes,
          value: _vm.filter.warranty,
          nullValue: ""
        },
        on: { change: _vm.handleFilterChange }
      }),
      _c("ma-input-select", {
        attrs: {
          type: "select",
          name: "subwarranty",
          col: "2",
          icon: "house",
          literal: "adminLayout.filters.subwarranty",
          options: _vm.subwarrantyTypes,
          value: _vm.filter.subwarranty,
          nullValue: ""
        },
        on: { change: _vm.handleSubfilterChange }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }